import { createI18n } from 'vue-i18n'
import en from './en.json'

const LOCALE_KEY = 'app-locale'

function getStoredLocale() {
  return 'en'
}

const i18n = createI18n({
  legacy: true,
  locale: getStoredLocale(),
  fallbackLocale: 'en',
  messages: { en }
})

export function setLocale(locale) {
  i18n.global.locale = 'en'
  localStorage.setItem(LOCALE_KEY, 'en')
  document.documentElement.lang = 'en'
}

export { LOCALE_KEY, getStoredLocale }
export default i18n
